export const initStateEnterprise = (
   Object.assign({
      data : [],
      logo            : '',
      enterprise_name : '',
      address         : '',
      telephone       : '',
      telephone_two   : '',
      email           : '',
      notary_name     : '',
      iva             : '',
      exchange_rate   : '',
      minimum_salary  : ''
   })
);